import { z } from 'zod';
import { SENTINEL_CONFIDENCES, SENTINEL_JUDGED_CATEGORIES } from './sentinel-labels';
// What the model is asked to answer with
export const sentinelVerdictSchema = z.object({
    category: z.enum(SENTINEL_JUDGED_CATEGORIES),
    confidence: z.enum(SENTINEL_CONFIDENCES),
    evidence: z.string()
});
export const SENTINEL_MODES = ['shadow', 'enforce'];
// What an agent is set to. Off is the absence of a mode: nothing is stored for it.
export const SENTINEL_AGENT_SETTINGS = ['off', ...SENTINEL_MODES];
export const SENTINEL_AGENT_SETTING_NAMES = {
    off: 'Off',
    shadow: 'Flag only',
    enforce: 'Take action'
};
// What Sentinel says before it ends a call: the built-in action, and the final message of the End call steps in the
// workflow it proposes
export const SENTINEL_CLOSING_LINE = "I'm sorry, I can't continue with this call. Goodbye.";
//# sourceMappingURL=sentinel.js.map